module.exports = __webpack_public_path__ + "static/media/OxygenRegular.aa109ade.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OxygenRegular/OxygenRegular.woff
// module id = 2937
// module chunks = 0